<template>
  <div id="add_form" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Preview Quick Reply</h5>
          <button
            id="btnCloseQuickReply"
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" :style=" 'background: url(\''+whatsappBackground+'\');'">
          <div class="chat">
            <div class="chat-box">
              <div class="chats">
                <div class="chat chat-right">
                  <div class="chat-body">
                    <div class="chat-bubble">
                      <div class="chat-content" style=" overflow-wrap: break-word;">
                        <div
                          class="chat-img-group clearfix"
                          v-if="formParamQRSt.header.message_type=='image' && formParamQRSt.header.button_type!='list_text'"
                        >
                          <a class="chat-img-attach" href="javascript:void(0)">
                            <img
                              style="max-height:200px;"
                              alt
                              :src="formParamQRSt.header.image_url"
                            />
                          </a>
                        </div>
                        <ul
                          class="attach-list"
                          v-if="formParamQRSt.header.message_type=='document' && formParamQRSt.header.button_type!='list_text'"
                        >
                          <li>
                            <i class="fa fa-file"></i>
                            <a :href="formParamQRSt.header.image_url" target="_blank">File</a>
                          </li>
                        </ul>
                        <p
                          v-html="messageFilter(formParamQRSt.header.message)"
                          v-if="formParamQRSt.header.message!=''"
                          v-linkified
                        ></p>
                        <span
                          v-html="formParamQRSt.header.footer_message"
                          class="text-muted"
                          style="font-size:10px;"
                          v-linkified
                          v-if="formParamQRSt.header.footer_message_status==true"
                        ></span>
                        <template v-if="formParamQRSt.detail_button.length">
                          <div v-if="formParamQRSt.header.button_type=='button'">
                            <div
                              class="text-center"
                              v-for="(rowVal,idx) in formParamQRSt.detail_button"
                              :key="idx"
                            >
                              <div
                                class="user-add-shedule-list"
                                v-if="rowVal.auto_reply_button_id!='' && idx<3"
                              >
                                <a href="javascript:void(0)">
                                  <i class="fa fa-tags"></i>
                                  {{getButtonLabelById(rowVal.auto_reply_button_id)}}
                                </a>
                              </div>
                            </div>
                          </div>
                          <div v-if="formParamQRSt.header.button_type=='list_text'">
                            <table class="table table-nowrap">
                              <template v-for="(rowVal,idx) in formParamQRSt.detail_button">
                                <tr v-if="rowVal.auto_reply_button_id!=''" :key="idx">
                                  <td>
                                    <label
                                      :for="rowVal.auto_reply_button_id"
                                    >{{getButtonLabelById(rowVal.auto_reply_button_id)}}</label>
                                  </td>
                                  <td>
                                    &nbsp;
                                    <input
                                      disabled
                                      name="radio_list_text"
                                      class="form-check-input"
                                      :id="rowVal.auto_reply_button_id"
                                      type="radio"
                                    />
                                  </td>
                                </tr>
                              </template>
                            </table>
                          </div>
                          <div v-if="formParamQRSt.header.button_type=='link'">
                            <div
                              class="text-center"
                              v-for="(rowVal,idx) in formParamQRSt.detail_button"
                              :key="idx"
                            >
                              <div
                                class="user-add-shedule-list"
                                v-if="rowVal.auto_reply_button_id!='' && idx<3"
                              >
                                <a
                                  href="javascript:void(0)"
                                  v-html="getLinkLabelById(rowVal.auto_reply_button_id)"
                                ></a>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>

                      <div
                        class="chat-content"
                        style=" overflow-wrap: break-word;"
                        v-if="(formParamQRSt.header.message_type=='image' || formParamQRSt.header.message_type=='document') && formParamQRSt.header.button_type=='list_text'"
                      >
                        <div
                          class="chat-img-group clearfix"
                          v-if="formParamQRSt.header.message_type=='image' && formParamQRSt.header.button_type=='list_text'"
                        >
                          <a class="chat-img-attach" href="javascript:void(0)">
                            <img
                              style="max-height:200px;"
                              alt
                              :src="formParamQRSt.header.image_url"
                            />
                          </a>
                        </div>
                        <ul
                          class="attach-list"
                          v-if="formParamQRSt.header.message_type=='document' && formParamQRSt.header.button_type=='list_text'"
                        >
                          <li>
                            <i class="fa fa-file"></i>
                            <a :href="formParamQRSt.header.image_url" target="_blank">File</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr v-if="formParamQRSt.header.is_enable_away_message_status==true" />
              <div class="chats" v-if="formParamQRSt.header.is_enable_away_message_status==true">
                <div class="chat chat-right">
                  <div class="chat-body">
                    <div class="chat-bubble">
                      <div class="chat-content">
                        <p
                          v-html="messageFilter(formParamQRSt.header.message_away)"
                          v-if="formParamQRSt.header.message_away!=''"
                          v-linkified
                        ></p>
                        <span
                          v-html="formParamQRSt.header.footer_message"
                          class="text-muted"
                          style="font-size:10px;"
                          v-linkified
                          v-if="formParamQRSt.header.footer_message_status==true"
                        ></span>
                        <template v-if="formParamQRSt.detail_button_away.length">
                          <div v-if="formParamQRSt.header.button_type_away_message=='button'">
                            <div
                              class="text-center"
                              v-for="(rowVal,idx) in formParamQRSt.detail_button_away"
                              :key="idx"
                            >
                              <div
                                class="user-add-shedule-list"
                                v-if="rowVal.auto_reply_button_id!=''"
                              >
                                <a href="javascript:void(0)">
                                  <i class="fa fa-tags"></i>
                                  {{getButtonLabelById(rowVal.auto_reply_button_id)}}
                                </a>
                              </div>
                            </div>
                          </div>
                          <div v-if="formParamQRSt.header.button_type_away_message=='link'">
                            <div
                              class="text-center"
                              v-for="(rowVal,idx) in formParamQRSt.detail_button_away"
                              :key="idx"
                            >
                              <div
                                class="user-add-shedule-list"
                                v-if="rowVal.auto_reply_button_id!=''"
                              >
                                <a
                                  href="javascript:void(0)"
                                  v-html="getLinkLabelById(rowVal.auto_reply_button_id)"
                                ></a>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="submit-section">
            <button class="btn btn-light submit-btn" data-dismiss="modal">Cancel</button>
            <button
              :disabled="isSending"
              class="btn btn-primary submit-btn"
              @click="sendQuickReply(formParamQRSt.header.id)"
            >Send</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getWhatsappNumberFromJid } from "@/utils/helper";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: {
    buttonsRows: {
      type: Array,
      default: () => [{ button_text: "" }]
    },
    linkRows: {
      type: Array
    }
  },
  data() {
    return {
      roomDetail: {
        room_title: "",
        provider: "",
        room_photo: "",
        update_datetime: 0,
        room_number: ""
      },
      whatsappBackground: process.env.VUE_APP_WHATSAPP_BACKGROUND,
      isLoading: false,
      buttonsLoading: false,
      isSending: false
      // buttonsRows: [],
      // linkRows: []
    };
  },
  watch: {
    isShowForm: {
      handler: function(val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          // this.settabMessage("setup");
          // this.selectedLicense = [];
          // this.buttonsRows = [];
          // this.linkRows = [];
          var that = this;
          setTimeout(function() {
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            if (
              that.formParamQRSt.header.id != "" &&
              that.formParamQRSt.header.id != null
            ) {
              if (
                typeof that.formParamQRSt.header.copy != "undefined" &&
                that.formParamQRSt.header.copy == true
              ) {
                that.formParamQRSt.header.id = "";
              }

              that.formParam = that.formParamQRSt;

              if (that.formParam.header.image_url != "") {
                that.formParam.header.is_enable_attach_file = true;
                that.uploadMessageType = that.formParam.header.message_type;
              } else {
                that.uploadMessageType = "image";
              }

              if (
                that.formParam.header.button_type == "button" ||
                that.formParam.header.button_type == "link"
              ) {
                if (
                  that.formParam.detail_button.length < that.defaultDetailButton
                ) {
                  let kekuranganBtn =
                    that.defaultDetailButton -
                    that.formParam.detail_button.length;
                  if (that.formParam.header.button_type == "list_text") {
                    kekuranganBtn =
                      that.defaultDetailListText -
                      that.formParam.detail_button.length;
                  }
                  for (var i = 0; i < kekuranganBtn; i++) {
                    that.formParam.detail_button.push({
                      auto_reply_button_id: ""
                    });
                  }
                }
              } else {
                if (
                  that.formParam.detail_button.length <
                  that.defaultDetailListText
                ) {
                  let kekuranganBtn =
                    that.defaultDetailButton -
                    that.formParam.detail_button.length;
                  if (that.formParam.header.button_type == "list_text") {
                    kekuranganBtn =
                      that.defaultDetailListText -
                      that.formParam.detail_button.length;
                  }
                  for (var i = 0; i < kekuranganBtn; i++) {
                    that.formParam.detail_button.push({
                      auto_reply_button_id: ""
                    });
                  }
                }
              }

              // that.loadReplyButtons();
              // that.loadReplyLink();
              console.log("that.formParam", that.formParam);
            } else {
              // that.loadReplyButtons();
              // that.loadReplyLink();
              that.formParam = {
                header: {
                  id: "",
                  title: "",
                  message: "",
                  is_enable_attach_file: false,
                  is_custom_url: false,
                  image_url: "",
                  message_type: "text",
                  button_type: "button"
                },
                detail_button: [
                  {
                    auto_reply_button_id: ""
                  },
                  {
                    auto_reply_button_id: ""
                  },
                  {
                    auto_reply_button_id: ""
                  },
                  {
                    auto_reply_button_id: ""
                  },
                  {
                    auto_reply_button_id: ""
                  },
                  {
                    auto_reply_button_id: ""
                  },
                  {
                    auto_reply_button_id: ""
                  },
                  {
                    auto_reply_button_id: ""
                  },
                  {
                    auto_reply_button_id: ""
                  },
                  {
                    auto_reply_button_id: ""
                  }
                ]
              };
            }
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["activeRoomId"]),
    formParamQRSt() {
      return this.$store.state.automation.formParamQRSt;
    }
  },
  methods: {
    async switchRoom() {
      this.loading = await true;
      this.roomDetail = await this.$store.getters.getRoomById(
        this.activeRoomId
      );

      var dataArr = [];
      dataArr = {
        room_id: this.roomDetail.id,
        room_title: this.roomDetail.room_title,
        room_photo: this.roomDetail.room_photo
      };
      await this.$root.$emit("switchRoom", dataArr);
      this.loading = await false;
    },
    getWhatsappNumberFromJid(jid) {
      return getWhatsappNumberFromJid(jid);
    },
    async sendQuickReply(id) {
      this.isSending = await true;
      this.roomDetail = await this.$store.getters.getRoomById(
        this.activeRoomId
      );

      //set false dulu
      this.loading = await true;
      this.$store.dispatch("automation/setIsShowForm", false);

      let dataParam = await {};
      dataParam = await {
        id: id,
        recipient_number: this.getWhatsappNumberFromJid(
          this.roomDetail.room_number
        )
      };
      await this.$store
        .dispatch("omniwa/sendQuickReply", dataParam) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          this.loading = false;
          this.isSending = false;
          document.getElementById("btnCloseQuickReply").click(); // Click on the checkbox
          this.$fire({
            title: "Processing",
            text: "Message is sending, please wait...",
            type: "warning",
            timer: 2000
          });
        });
      // var that = this;
      // setTimeout(function() {
      //   that.switchRoom();
      // }, 3000);
    },
    getButtonLabelById(id) {
      let arr = this.buttonsRows.find(msgs => msgs.id === id);
      if (arr != null && typeof arr.button_text != "undefined") {
        return arr.button_text;
      } else {
        return "";
      }
    },
    getLinkLabelById(id) {
      let arr = this.linkRows.find(msgs => msgs.id === id);
      if (arr != null && typeof arr.button_text != "undefined") {
        if (arr.button_type == "call") {
          return '<i class="fa fa-phone"></i> ' + arr.button_text;
        } else {
          return '<i class="fa fa-external-link"></i> ' + arr.button_text;
        }
      } else {
        return "";
      }
    },
    messageFilter(message) {
      return message.replace(/\r?\n/g, "<br />");
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>


// WEBPACK FOOTER //
// src/views/omni/components/quickReplyPreview.vue